export default __webpack_public_path__ + "static/media/david11.b9d0f461.jpg";